export function formatDate(value: string | null): string {
  if (!value) return "\u2014";
  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatDateTime(value: string | null): string {
  if (!value) return "—";
  return new Date(value).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/**
 * A photo's capture time. It is stored as a wall clock in UTC fields (docs/DECISIONS.md),
 * so it must be read back in UTC or the viewer's own zone would shift it.
 */
export function formatCapturedAt(value: string): string {
  return new Date(value).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: "UTC",
  });
}

/** "lat, lng", or null when the photo has no GPS. */
export function formatGps(lat: string | null, lng: string | null): string | null {
  return lat === null || lng === null ? null : `${lat}, ${lng}`;
}

export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}

/**
 * How a stored company stem reads on screen. The stem comes from the uploader's email
 * domain at import; a name here is only for display, and filters keep sending the stored
 * value. Anything not listed shows as stored.
 */
const COMPANY_NAMES: Record<string, string> = {
  reconcorporation: "Recon Corporation",
  eitrifoundry: "EITRI Foundry",
};

export function companyLabel(stored: string): string {
  return COMPANY_NAMES[stored] ?? stored;
}
